;(() => {
  // Parse an HTML string into a plain array of element nodes, dropping any
  // stray comments or text nodes that Slim's partial-boundary comments emit.
  function parseElements(html) {
    // `$(html)` keeps comments in the returned collection; filter by nodeType.
    return $(html)
      .get()
      .filter((n) => n.nodeType === 1)
  }

  // Replacement for the jQuery-UI based `pond` widget used by the price_match
  // and help_centre situational forms. Uses cash-dom for DOM work and
  // RailsRequest for the upload.

  class Pond {
    constructor(wrapper) {
      const $wrapper = $(wrapper)
      this.$list = $wrapper.find(".pond-img-list")
      this.$fileInput = $wrapper.find(".pond-new-img-field")
      this.uploading = 0

      const $form = $wrapper.closest("form")
      this.$submitButton = $form.find('[type="submit"]')
      this.$disableMessage = this.$submitButton
        .parent()
        .find(".disable_message")

      $wrapper.find(".pond-new-img").on("click", (e) => {
        e.preventDefault()
        this.$fileInput[0]?.click()
      })

      this.$fileInput.on("change", () => {
        const input = this.$fileInput[0]
        if (input?.files.length) {
          this.upload(Array.from(input.files))
          input.value = ""
        }
      })

      // Drag-and-drop support matching the old jQuery-UI fileupload dropZone
      wrapper.addEventListener("dragover", (e) => {
        e.preventDefault()
        e.stopPropagation()
      })
      wrapper.addEventListener("drop", (e) => {
        e.preventDefault()
        e.stopPropagation()
        const files = Array.from(e.dataTransfer?.files || []).filter((f) =>
          f.type.startsWith("image/"),
        )
        if (files.length) this.upload(files)
      })

      this.$list.on("click", ".pond-img-delete", (e) => {
        e.preventDefault()
        const item = e.target.closest(".pond-img")
        if (!item) return
        if (item._pondAbort) item._pondAbort()
        item.remove()
      })
    }

    buildPlaceholder() {
      const tpl = document.querySelector("#pond_img_template")
      // `tpl` is a `<template>` element — use innerHTML to get the HTML
      // serialization of its content fragment.
      return tpl ? parseElements(tpl.innerHTML || "")[0] || null : null
    }

    async upload(files) {
      for (const file of files) {
        await this.uploadOne(file)
      }
    }

    async uploadOne(file) {
      const placeholder = this.buildPlaceholder()
      if (placeholder) this.$list.append(placeholder)
      this.uploading += 1
      this.toggleSubmit()

      const controller = new AbortController()
      if (placeholder) placeholder._pondAbort = () => controller.abort()

      try {
        const formData = new FormData()
        formData.append("images[]", file)

        const response = await window.RailsRequest.post("/pond", {
          body: formData,
          signal: controller.signal,
          responseKind: "html",
        })
        if (!response.ok) throw new Error(`HTTP ${response.statusCode}`)
        const newNodes = parseElements(await response.html)

        if (placeholder) {
          const replacement = newNodes[0]
          if (!replacement) {
            placeholder.remove()
          } else {
            const error = replacement.dataset?.error
            if (error) {
              alert(error)
              placeholder.remove()
            } else {
              placeholder.replaceWith(replacement)
            }
          }
        }
      } catch (err) {
        if (placeholder) placeholder.remove()
        if (err.name !== "AbortError") {
          alert("Could not upload your photo. Please, try again.")
          console.error(err)
        }
      } finally {
        this.uploading -= 1
        if (this.uploading < 0) this.uploading = 0
        this.toggleSubmit()
      }
    }

    toggleSubmit() {
      const disabled = this.uploading > 0
      this.$submitButton.prop("disabled", disabled)
      this.$disableMessage.toggle(disabled)
    }
  }

  function init() {
    $(".pond").each((_, el) => {
      if (el._pondInitialized) return
      el._pondInitialized = true
      new Pond(el)
    })
  }

  $(init)
  document.addEventListener("turbo:frame-load", init)
})()
